import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchMessageTemplate, createMessageTemplate, updateMessageTemplate } from './actions';
import MessageTemplateSettingsForm from './SettingsForm';
import authUtils from '../../auth/utils';
import { Panel } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';

class Details extends Component {
	constructor(props) {
		super(props);
		this.handleMessageTemplateSettingsSubmit = this.handleMessageTemplateSettingsSubmit.bind(this);
	}

	componentDidMount() {
		const { match, fetchMessageTemplate } = this.props;
		const messageTemplateId = match.params.id;

		if (messageTemplateId) {
			fetchMessageTemplate(messageTemplateId);
		}
	}

	handleMessageTemplateSettingsSubmit(values) {
		const { messageTemplate, createMessageTemplate, updateMessageTemplate, history } = this.props;

		if (messageTemplate) {
			updateMessageTemplate(messageTemplate.id, values);
		} else {
			createMessageTemplate(values, history);
		}
	}

	render() {
		const { messageTemplate, isReadonly, messageTemplateTypes, fromAddressTypes, isSystem, tagCatalog, t } = this.props;
		const initialValues = messageTemplate ? messageTemplate : { fromAddressType: 1, isSystem };
		return <Panel>
			<Panel.Heading>{t('Common_Details')}</Panel.Heading>
			<Panel.Body>
				<MessageTemplateSettingsForm isReadonly={isReadonly} onSubmit={this.handleMessageTemplateSettingsSubmit} initialValues={initialValues} messageTemplateTypes={messageTemplateTypes} fromAddressTypes={fromAddressTypes} tagCatalog={tagCatalog} />
			</Panel.Body>
		</Panel>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const messageTemplateId = ownProps.match.params.id;
	const isSystem = ownProps.match.params.category && ownProps.match.params.category === 'system';

	const {
		entities: { messageTemplates },
		auth: { currentUser },
		lookups
	} = state;

	return {
		messageTemplate: messageTemplates[messageTemplateId],
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'MessageTemplates'),
		messageTemplateTypes: lookups.messageTemplateTypes,
		fromAddressTypes: lookups.fromAddressTypes,
		tagCatalog: state.messageTemplateTags,
		isSystem
	};
};

export default connect(mapStateToProps, {
	fetchMessageTemplate,
	createMessageTemplate,
	updateMessageTemplate
})(withTranslation()(Details));